import { helper } from "@ember/component/helper";
import { capitalize as _capitalize } from "@ember/string";
import { createStringHelperFunction } from "./titleize";

export const capitalize = createStringHelperFunction(_capitalize);
export default helper(capitalize);
